module.exports = __webpack_public_path__ + "media/icons/chevron-right-6fc5dd5593f4270dd7af93e14bb0b53a.svg";